/**
 * @file experiences.js
 * Exports constants pertaining to experiences.
 */

export const EXPERIENCES_FETCH_FOR_USER = 'EXPERIENCES_FETCH_FOR_USER';
export const EXPERIENCES_CREATE = 'EXPERIENCES_CREATE';
export const EXPERIENCES_EDIT = 'EXPERIENCES_EDIT';



// WEBPACK FOOTER //
// ./src/constants/experiences.js